export const BUTTON_IDS = {
  INSTANCE: 'instance-characterisation-button',
  SERIES: 'series-characterisation-button',
  STUDY: 'study-characterisation-button',
  PATIENT: 'patient-characterisation-button',
  REPORT: 'report-characterisation-button',
};
